import dashboard from './dashboard'
import users from './users'
import transaction from './transaction'
import logs from './logs'
import reports from './reports'
import settings from './settings'

export default [...dashboard, ...users, ...transaction, ...logs, ...reports, ...settings]
